<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    :persistent="settingsDialogOpen"
    location="bottom end"
    offset="10"
    min-width="340"
    max-width="340"
  >
    <template #activator="{ props: menuProps }">
      <v-tooltip location="bottom" text="Org Settings">
        <template #activator="{ props: tipProps }">
          <AppBarHitButton
            v-bind="{ ...menuProps, ...tipProps }"
            aria-label="Org Settings"
          >
            <AppIcon name="mdi-cog-outline" :size="20" />
          </AppBarHitButton>
        </template>
      </v-tooltip>
    </template>

    <div class="app-bar-settings-menu">
      <OrgSettingsDropdownPanel
        :search="search"
        :categories="navItems"
        :active-id="activeCategoryId"
        @update:search="search = $event"
        @select="onSelect"
      />
    </div>
  </v-menu>
</template>

<script>
import AppIcon from "@/components/Extras/AppIcon.vue";
import AppBarHitButton from "@/components/Extras/AppBarHitButton.vue";
import OrgSettingsDropdownPanel from "@/components/MasterSettings/OrganizationSettings/OrgSettingsDropdownPanel.vue";
import { buildOrganizationNavItems } from "@/constants/organizationSettingsNav.js";
import {
  openOrganizationSetting,
  onOrganizationSettingActive,
  onOrganizationSettingDialogOpen,
  requestOrgSettingsHost,
} from "@/utils/orgSettingsLauncher.js";

export default {
  name: "AppBarSettingsMenu",
  components: { AppIcon, AppBarHitButton, OrgSettingsDropdownPanel },
  data() {
    return {
      menuOpen: false,
      search: "",
      activeCategoryId: null,
      settingsDialogOpen: false,
    };
  },
  computed: {
    orgDetails() {
      return this.$store.getters.get_current_user_details?.organization_details;
    },
    navItems() {
      const items = buildOrganizationNavItems(this.orgDetails);
      return (Array.isArray(items) ? items : []).filter(
        (c) => c.id !== "web-hook",
      );
    },
  },
  watch: {
    "$route.name"(name) {
      if (name === "OrganizationSettings") {
        this.menuOpen = false;
      }
    },
    menuOpen(open) {
      if (open) {
        requestOrgSettingsHost();
      } else {
        this.search = "";
      }
    },
    settingsDialogOpen(open) {
      if (open && this.$route.name !== "OrganizationSettings") {
        this.menuOpen = true;
      }
    },
  },
  mounted() {
    this._unsubActive = onOrganizationSettingActive((id) => {
      this.activeCategoryId = id;
    });
    this._unsubDialogOpen = onOrganizationSettingDialogOpen((open) => {
      this.settingsDialogOpen = open;
      if (open && this.$route.name !== "OrganizationSettings") {
        this.menuOpen = true;
      }
    });
  },
  beforeUnmount() {
    this._unsubActive?.();
    this._unsubDialogOpen?.();
  },
  methods: {
    onSelect(categoryId) {
      openOrganizationSetting(categoryId);
    },
  },
};
</script>

<style scoped>
.app-bar-settings-menu {
  border-radius: 16px;
  overflow: hidden;
}
</style>
